/**
 * 需求来源：docs/新增CJ招聘落地页需求/prompt.md、docs/新增CJ招聘落地页需求/CJ-333291
 * 注意事项：
 * 1. 所有文案统一走 i18next.t(key, fallback) 以兼容 SSR 与翻译上报。
 * 2. 本文件仅维护展示层常量，不承载跳转或状态逻辑。
 */
var i18nextFallback = { t: function(key, defaultValue) { return defaultValue; } };
var i18next = (typeof window !== 'undefined' && window.i18next && window.i18next.isInitialized) ? window.i18next : i18nextFallback;

// 招聘相关跳转地址
var LINKS = {
  hrEmail: 'hr@cjdropshipping.co',
  // WhatsApp 可由后续运营替换为实际号码
  whatsapp: 'https://wa.me/',
};

/**
 * @param {string} [cdnHost] SSR 由 fetch.js 传入的 CDN_HOST/OSS_HOST（按环境取值的 OSS 裸域名，dev 为 test OSS）。
 *   OSS 域名按环境区分（参考各端 ossController：prod=sv-resource.oss-accelerate、
 *   test=test-cj-frontend.oss-cn-hangzhou、prod-cn=cj-front-end.oss-cn-hangzhou），不硬编码 host。
 *   careers 视频：OSS resourcesUnlimit/careers/ → cdnHost + /resourcesUnlimit/careers/<file>。
 * @param {string} [publicImg] SSR 由 fetch.js 传入的 PUBLIC_IMG（图片基址，dev=/egg/image 本地直出、prod=OSS+/egg/image）。
 *   careers 图片：public/egg/image/careers/ → oss-up-egg 上传 egg/image/ → publicImg + /careers/<file>。
 */
function getConstants(cdnHost, publicImg) {
  if (typeof window !== 'undefined' && window.i18next && !window.i18next.isInitialized && window.LNG) {
    var lng = (document.cookie.match(/(?:^|;\s*)lng=([^;]*)/) || [])[1] || 'en';
    window.i18next.init({
      lng: lng,
      debug: false,
      resources: { [lng]: { translation: window.LNG } },
      keySeparator: '__keySeparator__',
      nsSeparator: '__nsSeparator__'
    });
  }

  i18next = (typeof window !== 'undefined' && window.i18next && window.i18next.isInitialized) ? window.i18next : i18nextFallback;

  // 图片/视频等媒体地址不参与翻译上报：直接用普通常量，不走 i18next.t（避免上报词含 http 链接）
  // OSS 裸域名（按环境取值，不硬编码；参考 ossController/ossHost[NODE_ENV]）：
  //   优先 SSR 传入 cdnHost(=CDN_HOST/OSS_HOST)，其次客户端全局 OSS_HOST/CDN_HOST，dev 回退空串。
  var ossHost = (cdnHost
    || (typeof OSS_HOST !== 'undefined' && OSS_HOST)
    || (typeof CDN_HOST !== 'undefined' && CDN_HOST)
    || '').replace(/\/$/, '');
  // 图片基址：按需求用 PUBLIC_IMG（dev=/egg/image 本地直出、prod=OSS+/egg/image）。
  //   优先 SSR 传入 publicImg，其次客户端全局 PUBLIC_IMG，最后回退本地相对 /egg/image。
  var imgBase = publicImg
    || (typeof PUBLIC_IMG !== 'undefined' && PUBLIC_IMG)
    || '/egg/image';
  var IMG = imgBase.replace(/\/$/, '') + '/careers/';
  // 视频：资源仅在 OSS（resourcesUnlimit/careers/，test/prod 均探测 200），无本地副本，
  //   故始终用 ossHost；dev 下 ossHost 由 devOssHost(=test OSS) 注入，可直连。
  var VIDEO = ossHost + '/resourcesUnlimit/careers/';
  // 视频封面取 OSS mp4 首帧：阿里云 OSS video/snapshot 处理参数（t_0 首帧、f_jpg、原始宽高、m_fast）。
  // 注意：snapshot 基于干净的视频 URL，不能带 #t=0.1 媒体片段。
  function videoPoster(videoUrl) {
    return videoUrl + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast';
  }
  var DEFAULT_MEDIA = IMG + 'life-poster.jpg';

  var HERO = {
    badge: i18next.t('careers-hero-badge', "We're Hiring · Global Partners Wanted"),
    title: i18next.t('careers-hero-title', 'Worldwide Reach.'),
    titleHighlight: i18next.t('careers-hero-title-highlight', 'Join Our Global Journey.'),
    kicker: i18next.t('careers-hero-kicker', 'Build the future of cross-border e-commerce and dropshipping — across every market that matters.'),
    desc: i18next.t('careers-hero-desc', "As a leading cross-border e-commerce and dropshipping fulfillment platform, we're scaling our global footprint at speed. We're looking for high-performing, visionary talents to drive worldwide growth, localization, forge strategic partnerships."),
    primaryCta: i18next.t('careers-hero-primary-cta', 'View Open Roles'),
    secondaryCta: i18next.t('careers-hero-secondary-cta', 'Apply Now'),
    image: IMG + 'banner.jpg',
    imageAlt: i18next.t('careers-hero-image-alt', 'Global cross-border e-commerce team'),
    tags: [
      i18next.t('careers-hero-tag-1', 'Global Markets'),
      i18next.t('careers-hero-tag-2', 'High Growth'),
      i18next.t('careers-hero-tag-3', 'Strategic Partnerships')
    ]
  };

  var MARKETS = {
    label: i18next.t('careers-markets-label', 'Operating across 18+ countries & regions · and expanding'),
    // 高亮片段：MarketsSection 会把 label 中的该子串替换为 primary-2 高亮
    labelHighlight: i18next.t('careers-markets-label-highlight', '18+'),
    countries: [
      { code: 'au', name: i18next.t('careers-country-au', 'Australia') },
      { code: 'br', name: i18next.t('careers-country-br', 'Brazil') },
      { code: 'ca', name: i18next.t('careers-country-ca', 'Canada') },
      { code: 'cn', name: i18next.t('careers-country-cn', 'China') },
      { code: 'fr', name: i18next.t('careers-country-fr', 'France') },
      { code: 'de', name: i18next.t('careers-country-de', 'Germany') },
      { code: 'id', name: i18next.t('careers-country-id', 'Indonesia') },
      { code: 'jp', name: i18next.t('careers-country-jp', 'Japan') },
      { code: 'my', name: i18next.t('careers-country-my', 'Malaysia') },
      { code: 'mx', name: i18next.t('careers-country-mx', 'Mexico') },
      { code: 'ph', name: i18next.t('careers-country-ph', 'Philippines') },
      { code: 'pl', name: i18next.t('careers-country-pl', 'Poland') },
      { code: 'ro', name: i18next.t('careers-country-ro', 'Romania') },
      { code: 'es', name: i18next.t('careers-country-es', 'Spain') },
      { code: 'th', name: i18next.t('careers-country-th', 'Thailand') },
      { code: 'ae', name: i18next.t('careers-country-ae', 'United Arab Emirates') },
      { code: 'gb', name: i18next.t('careers-country-gb', 'United Kingdom') },
      { code: 'us', name: i18next.t('careers-country-us', 'United States') }
    ]
  };

  var GLOBAL = {
    eyebrow: i18next.t('careers-global-eyebrow', 'Our Global Presence'),
    title: i18next.t('careers-global-title', 'Where We Operate'),
    subtitle: i18next.t('careers-global-subtitle', "We're building local teams across key logistics and e-commerce hubs worldwide — hiring people who truly understand local markets."),
    hubs: [
      { icon: 'apartment', title: i18next.t('careers-global-hub-4-title', 'Europe'), desc: i18next.t('careers-global-hub-4-desc-v2', 'Netherlands · Germany · Türkiye') },
      { icon: 'travel', title: i18next.t('careers-global-hub-3-title', 'Oceania'), desc: i18next.t('careers-global-hub-3-desc', 'Australia') },
      { icon: 'public', title: i18next.t('careers-global-hub-2-title', 'Southeast Asia'), desc: i18next.t('careers-global-hub-2-desc-v2', 'Vietnam · Thailand · Indonesia · Malaysia') },
      { icon: 'landscape', title: i18next.t('careers-global-hub-6-title', 'Africa'), desc: i18next.t('careers-global-hub-6-desc-v2', 'Morocco · Nigeria') },
      { icon: 'domain', title: i18next.t('careers-global-hub-5-title', 'Middle East'), desc: i18next.t('careers-global-hub-5-desc-v2', 'Dubai · Saudi Arabia') },
      { icon: 'warehouse', title: i18next.t('careers-global-hub-7-title', 'North America'), desc: i18next.t('careers-global-hub-7-desc', 'Canada · USA') },
      { icon: 'flight', title: i18next.t('careers-global-hub-8-title', 'Latin America'), desc: i18next.t('careers-global-hub-8-desc-v2', 'Mexico · Brazil') },
      { icon: 'more', title: i18next.t('careers-global-hub-1-title-v2', 'More'), desc: i18next.t('careers-global-hub-1-desc-v2', 'More markets coming soon') }
    ]
  };

  var WHY = {
    eyebrow: i18next.t('careers-why-eyebrow', 'Why Join Us'),
    title: i18next.t('careers-why-title', 'Why Build Your Career at CJ Dropshipping'),
    subtitle: i18next.t('careers-why-subtitle', "More than a job — a stage to grow alongside a truly global platform. We're results-driven, and people-focused."),
    perks: [
      { icon: 'explore', title: i18next.t('careers-why-perk-1-title', 'Global Mobility'), desc: i18next.t('careers-why-perk-1-desc', 'Real cross-border career stages across Southeast Asia, Europe, the Middle East and the Americas. Overseas assignments and cross-regional collaboration expand your professional map as we scale worldwide.') },
      { icon: 'rocket', title: i18next.t('careers-why-perk-2-title', 'Fast-Track Growth'), desc: i18next.t('careers-why-perk-2-desc', 'In a high-growth industry, 0-to-1 opportunities are everywhere. Top performers rise faster — here, capability sets your pace, not seniority.') },
      { icon: 'paid', title: i18next.t('careers-why-perk-3-title', 'Competitive Rewards'), desc: i18next.t('careers-why-perk-3-desc', 'Market-leading compensation plus performance-driven incentives and commission. The value you created for the business will turn into generous rewards.') },
      { icon: 'diversity', title: i18next.t('careers-why-perk-4-title', 'Diverse & Inclusive'), desc: i18next.t('careers-why-perk-4-desc', 'Colleagues from different countries and cultures work side by side. Openness, equality and mutual success define how we collaborate.') },
      { icon: 'celebration', title: i18next.t('careers-why-perk-5-title', 'Retreats & Team Building'), desc: i18next.t('careers-why-perk-5-desc', 'Bali retreats, annual galas, festive parties and outdoor challenges — we work hard and live fully, our teammates are family members.') },
      { icon: 'school', title: i18next.t('careers-why-perk-6-title', 'Learning & Enablement'), desc: i18next.t('careers-why-perk-6-desc', 'Structured training, industry summits and shared global resources keep you at the forefront of cross-border e-commerce.') }
    ]
  };

  var LIFE = {
    eyebrow: i18next.t('careers-life-eyebrow', 'Life at CJ Dropshipping'),
    title: i18next.t('careers-life-title', 'Step Inside Our World'),
    subtitle: i18next.t('careers-life-subtitle', 'Experience our collaborative, global workspace through real footage from our teams.'),
    badge: i18next.t('careers-life-badge', 'Featured · Team Culture'),
    featureTitle: i18next.t('careers-life-feature-title', 'CJ Elite Global Journey'),
    featureDesc: i18next.t('careers-life-feature-desc', 'Go behind the scenes of our passionate, world-class team — where high energy meets operational excellence.'),
    playCta: i18next.t('careers-life-play', 'Watch Full Video'),
    fullscreenCta: i18next.t('careers-life-fullscreen', 'Fullscreen'),
    video: VIDEO + 'Step%20Inside%20Our%20World-3.mp4',
    poster: videoPoster(VIDEO + 'Step%20Inside%20Our%20World-3.mp4'),
    thumbs: [
      { icon: 'beach', video: VIDEO + 'Step%20Inside%20Our%20World-3.mp4', poster: videoPoster(VIDEO + 'Step%20Inside%20Our%20World-3.mp4'), title: i18next.t('careers-life-thumb-3-title', 'CJ Elite Global Journey'), sub: i18next.t('careers-life-thumb-3-sub', 'Now Playing') },
      { icon: 'play', video: VIDEO + 'Step%20Inside%20Our%20World-1.mp4', poster: videoPoster(VIDEO + 'Step%20Inside%20Our%20World-1.mp4'), title: i18next.t('careers-life-thumb-2-title', 'United in Pursuit of Passion'), sub: i18next.t('careers-life-thumb-1-sub', 'Team Culture') },
      { icon: 'groups', video: VIDEO + 'Step%20Inside%20Our%20World-2.mp4', poster: videoPoster(VIDEO + 'Step%20Inside%20Our%20World-2.mp4'), title: i18next.t('careers-life-thumb-1-title', 'Elite Sales, Elated Sails'), sub: i18next.t('careers-life-thumb-2-sub', 'Team Culture') },
      { icon: 'groups', video: VIDEO + 'Step%20Inside%20Our%20World-4.mp4', poster: videoPoster(VIDEO + 'Step%20Inside%20Our%20World-4.mp4'), title: i18next.t('careers-life-thumb-4-title', 'CCTV Report'), sub: i18next.t('careers-life-thumb-4-sub', 'Team Culture') }
    ]
  };

  var GALLERY = {
    eyebrow: i18next.t('careers-gallery-eyebrow', 'Working at CJ Dropshipping'),
    title: i18next.t('careers-gallery-title', 'Life Beyond the Desk'),
    subtitle: i18next.t('careers-gallery-subtitle', 'From annual galas to overseas summits, outdoor challenges to festive parties — we work hard, and we love harder.'),
    items: [
      { size: 'wideTall', image: IMG + 'gallery-annual-convention.jpg', cap: i18next.t('careers-gallery-1-cap', 'Annual Global Convention') },
      { size: '', image: IMG + 'gallery-team-building.jpg', cap: i18next.t('careers-gallery-2-cap', 'Team Building') },
      { size: '', image: IMG + 'gallery-gala-night.jpg', cap: i18next.t('careers-gallery-3-cap', 'Annual Gala Night') },
      { size: '', image: IMG + 'gallery-outdoor-challenge.jpg', cap: i18next.t('careers-gallery-4-cap', 'Outdoor Challenge') },
      { size: '', image: IMG + 'gallery-festive-spirit.jpg', cap: i18next.t('careers-gallery-5-cap', 'Festive Spirit') },
      { size: 'wide', image: IMG + 'gallery-shared-meals_1.jpg', cap: i18next.t('careers-gallery-6-cap', 'Shared Meals, Shared Growth') },
      { size: '', image: IMG + 'gallery-holiday-party.jpg', cap: i18next.t('careers-gallery-7-cap', 'Holiday Party') }
    ]
  };

  // Work Locations · Overseas Postings：置于 JobsSection 与 GallerySection 之间（参考稿 .worksite）
  var WORKSITE = {
    title: i18next.t('careers-worksite-title', 'Work Locations · Overseas Postings'),
    desc: i18next.t('careers-worksite-desc', 'All roles above can be based at any of the following overseas stations (exact role & city confirmed during the interview).'),
    locations: [
      i18next.t('careers-worksite-loc-17', 'USA'),
      i18next.t('careers-worksite-loc-1', 'Türkiye'),
      i18next.t('careers-worksite-loc-2', 'Mexico'),
      i18next.t('careers-worksite-loc-3', 'Brazil'),
      i18next.t('careers-worksite-loc-4', 'Vietnam'),
      i18next.t('careers-worksite-loc-5', 'Australia'),
      i18next.t('careers-worksite-loc-6', 'Canada'),
      i18next.t('careers-worksite-loc-7', 'Indonesia'),
      i18next.t('careers-worksite-loc-8', 'Thailand'),
      i18next.t('careers-worksite-loc-9', 'the Netherlands'),
      i18next.t('careers-worksite-loc-10', 'Spain'),
      i18next.t('careers-worksite-loc-11', 'Malta'),
      i18next.t('careers-worksite-loc-12', 'UAE'),
      i18next.t('careers-worksite-loc-13', 'Saudi Arabia'),
      i18next.t('careers-worksite-loc-14', 'Morocco'),
      i18next.t('careers-worksite-loc-15', 'Pakistan'),
      i18next.t('careers-worksite-loc-16', 'India')
    ]
  };

  var JOBS = {
    eyebrow: i18next.t('careers-jobs-eyebrow', 'Open Positions'),
    title: i18next.t('careers-jobs-title', 'Find Your Next Big Opportunity'),
    subtitle: i18next.t('careers-jobs-subtitle', 'Take the next major step of your career with our fast-growing global team.'),
    hotLabel: i18next.t('careers-jobs-hot', 'Hot'),
    locationLabel: i18next.t('careers-jobs-location', 'Multiple Locations'),
    highlightsLabel: i18next.t('careers-jobs-highlights', 'Highlights'),
    requirementsLabel: i18next.t('careers-jobs-requirements', 'Requirements'),
    applyCta: i18next.t('careers-jobs-apply', 'Apply Now'),
    items: [
      {
        image: IMG + 'job-1.jpg',
        title: i18next.t('careers-job-1-title', 'Overseas Market Lead'),
        subtitle: i18next.t('careers-job-1-subtitle', 'Dropshipping · 0-to-1 Market Launch'),
        highlights: [
          i18next.t('careers-job-1-hl-1', 'End-to-end 0-to-1 market launch'),
          i18next.t('careers-job-1-hl-2', 'Lead platform go-to-market strategy'),
          i18next.t('careers-job-1-hl-3', 'Build and manage local teams'),
          i18next.t('careers-job-1-hl-4', 'B2B clients acquisition'),
          i18next.t('careers-job-1-hl-5', 'Supply chain optimization')
        ],
        requirements: [
          i18next.t('careers-job-1-rq-1', 'Fluent in English and the local language'),
          i18next.t('careers-job-1-rq-2', 'Dropshipping / e-commerce expansion experience'),
          i18next.t('careers-job-1-rq-3', 'Strong local market knowledge'),
          i18next.t('careers-job-1-rq-4', 'Excellent negotiation skills')
        ]
      },
      {
        image: IMG + 'job-2.jpg',
        title: i18next.t('careers-job-2-title', 'Overseas Market BD'),
        subtitle: i18next.t('careers-job-2-subtitle', 'Dropshipping Business Development'),
        highlights: [
          i18next.t('careers-job-2-hl-1', 'Local dropshipping business development'),
          i18next.t('careers-job-2-hl-2', 'Resource integration (logistics / payments / KOLs)'),
          i18next.t('careers-job-2-hl-3', 'Partner relationship management'),
          i18next.t('careers-job-2-hl-4', 'Market expansion')
        ],
        requirements: [
          i18next.t('careers-job-2-rq-1', 'Fluent English; native speakers preferred'),
          i18next.t('careers-job-2-rq-2', "Bachelor's degree or above"),
          i18next.t('careers-job-2-rq-3', 'Dropshipping / cross-border e-commerce experience'),
          i18next.t('careers-job-2-rq-4', 'Outstanding communication skills')
        ]
      },
      {
        image: IMG + 'job-3.jpg',
        title: i18next.t('careers-job-3-title', 'Overseas HR & Admin Specialist'),
        subtitle: '',
        highlights: [
          i18next.t('careers-job-3-hl-1', 'End-to-end recruitment lifecycle'),
          i18next.t('careers-job-3-hl-2', 'Multi-site coordination'),
          i18next.t('careers-job-3-hl-3', 'Legal & compliance coordination'),
          i18next.t('careers-job-3-hl-4', 'Administrative support'),
          i18next.t('careers-job-3-hl-5', 'Team culture building')
        ],
        requirements: [
          i18next.t('careers-job-3-rq-1', 'Degree in HR/ Administration/ Business related majors'),
          i18next.t('careers-job-3-rq-2', 'Fluent in English and the local language'),
          i18next.t('careers-job-3-rq-3', '1-3 years of HR experience'),
          i18next.t('careers-job-3-rq-4', 'Detail-oriented and professional')
        ]
      }
    ]
  };

  var PROCESS = {
    eyebrow: i18next.t('careers-process-eyebrow', 'How To Apply'),
    title: i18next.t('careers-process-title', 'Join Us in Four Simple Steps'),
    subtitle: i18next.t('careers-process-subtitle', 'A transparent, efficient hiring process designed to get you onboard faster.'),
    steps: [
      { no: i18next.t('careers-process-step-1-no', 'STEP 01'), icon: 'send', title: i18next.t('careers-process-step-1-title', 'Apply'), desc: i18next.t('careers-process-step-1-desc', 'Submit your resume and target role via email or WhatsApp.') },
      { no: i18next.t('careers-process-step-2-no', 'STEP 02'), icon: 'forum', title: i18next.t('careers-process-step-2-title', 'Screening'), desc: i18next.t('careers-process-step-2-desc', 'An online HR screening to understand your background and career goals.') },
      { no: i18next.t('careers-process-step-3-no', 'STEP 03'), icon: 'groups', title: i18next.t('careers-process-step-3-title', 'Interview'), desc: i18next.t('careers-process-step-3-desc', 'An in-depth conversation with the hiring manager — a genuine two-way fit.') },
      { no: i18next.t('careers-process-step-4-no', 'STEP 04'), icon: 'verified', title: i18next.t('careers-process-step-4-title', 'Offer & Onboard'), desc: i18next.t('careers-process-step-4-desc', 'Receive your offer and begin your global cross-border career.') }
    ]
  };

  var CONTACT = {
    title: i18next.t('careers-contact-title', 'Ready to Join Our Team?'),
    subtitle: i18next.t('careers-contact-subtitle', 'Open to talents worldwide — take the next step and apply directly via email or WhatsApp.'),
    email: LINKS.hrEmail,
    copyLabel: i18next.t('careers-contact-copy', 'Copy email'),
    copiedLabel: i18next.t('careers-contact-copied', 'Copied'),
    divider: i18next.t('careers-contact-divider', 'or connect instantly'),
    whatsappCta: i18next.t('careers-contact-whatsapp', 'Apply via WhatsApp'),
    // 二维码：地址不上报，走 /static/image/careers/（打包自动上传 OSS）
    qrImage: IMG + 'qr_code.png',
    qrLabel: i18next.t('careers-contact-qr-label', 'Scan to apply on WhatsApp'),
    // 投递须知（参考稿 .resume-note）：前缀文案 + 加粗字段说明
    resumeNote: i18next.t('careers-contact-resume-note', 'When applying, please note'),
    resumeNoteFields: i18next.t('careers-contact-resume-fields', 'Role · Nationality · Preferred Posting Country · Name · Email · Availability Date')
  };

  var FLOAT_CTA = i18next.t('careers-float-cta', 'Apply Now');

  return {
    HERO: HERO,
    MARKETS: MARKETS,
    GLOBAL: GLOBAL,
    WHY: WHY,
    LIFE: LIFE,
    GALLERY: GALLERY,
    WORKSITE: WORKSITE,
    JOBS: JOBS,
    PROCESS: PROCESS,
    CONTACT: CONTACT,
    FLOAT_CTA: FLOAT_CTA
  };
}

module.exports = {
  getConstants: getConstants,
  LINKS: LINKS
};
